import { useEffect } from 'react';

import { importFormDate } from 'utils/formatDate';
import { useQuery } from '@tanstack/react-query';
import { getArtworkDocuments, getQaSpecTemplateDocuments } from 'services/product';


export const useSetFormUpdateDocsAndCertification = ({
  isEnabled,
  type,
  dataForm,
  formInstance,
}) => {
  useEffect(() => {
    if (isEnabled) {
      if (type === 'document') {
        formInstance.setFieldsValue(dataForm);
      } else {
        const { certificateExpiryDate } = dataForm;
        formInstance.setFieldsValue({
          ...dataForm,
          certificateExpiryDate: importFormDate(certificateExpiryDate),
        });
      }
    }
    return;
  }, [dataForm, type, isEnabled, formInstance]);
};

export const useArtworkDocuments = (productId, options = {}) => {
  return useQuery({
    queryKey: ['artworkDocuments', productId],
    queryFn: async () => {
      const response = await getArtworkDocuments(productId);
      return response.data;
    },
    ...options,
    enabled: !!productId,
  });
};

export const useQaSpecTemplateDocuments = (productId, options = {}) => {
  return useQuery({
    queryKey: ['qaSpecTemplateDocuments', productId],
    queryFn: async () => {
      const response = await getQaSpecTemplateDocuments(productId);
      return response.data;
    },
    ...options,
    enabled: !!productId,
  });
};
